import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {HostingService} from "../../hosting.service";
import {HostingDomainData} from "../../domains/hostingDomainData";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {DbServerErrors} from "../../../../../shared/interceptors/db-server-errors";
import {Utils} from "../../../../../shared/utils/utils";
import {Website} from "../../../website";
import { filter, first } from "rxjs";

export interface IGeneratePasswordData {
  website: Website;
  selectedDialog: string;
}
@Component({
    selector: 'db-custom-https',
    templateUrl: './custom-https.component.html',
    styleUrls: ['./custom-https.component.scss'],
    standalone: false
})
export class CustomHttpsComponent extends DialogComponent<IGeneratePasswordData, Boolean> implements OnInit, IGeneratePasswordData {

  @Input() website: Website;
  @Input() selectedDialog: string;
  public isMobile: boolean;
  public continue: boolean = false;
  public loading: boolean;
  public allDomains: HostingDomainData[];
  public domains: FormControl;
  public generateCustomCertificate: FormGroup;
  public domainNameIds: any;
  public serverErrors: DbServerErrors;
  public hasServerFieldErrors: boolean;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
    private _hostingService: HostingService
  ) {
    super(
      _dialogService
    );

    this.generateCustomCertificate = new FormGroup({
      'keyFileContents': new FormControl('', [Validators.required]),
      'certFileContents': new FormControl('', [Validators.required]),
      'caFileContents': new FormControl(''),
      'redirectHttp': new FormControl(1)
    });
  }

  ngOnInit() {
    this.domainNameIds = [];
    this.domains = new FormControl("");
    this._store.select(fromStore.getDomains(this.website.id)).subscribe((domains: HostingDomainData[]) => {
      if (domains) {
        this.allDomains = domains;
      }
    });
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }


  public generateCertificate(): void {
    if (this.generateCustomCertificate.valid) {
      this.loading = true;
      this.serverErrors = null;
      this.hasServerFieldErrors = false;
      this._hostingService.generateCustomCertificate(this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id, this.generateCustomCertificate.value)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response: DbResponse): void => {
          this.loading = false;
          if (response.success) {
            this.confirm();
            NotifierComponent.notify(new Notification("Certificate created successfully", NotificationType.SUCCESS));
            this._store.dispatch(new fromStore.LoadCloudflareDefaultRecord(this.website.id));
          } else {
            this.serverErrors = response.serverErrors;
            this.checkHasServerFieldErrors(response.serverErrors);

          }
        });
    }
  }

  private checkHasServerFieldErrors(serverErrors: DbServerErrors): void {
    this.hasServerFieldErrors = !!Utils.intersect(Object.keys(serverErrors.fields), ['key_file_content', 'cert_file_content']).length;
  }

  public back(): void {
    this.continue = false;
  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

  public confirm(): void {
    this.result = true;
    this.close();
  }

}
